import { useMutation, useQueryClient } from 'react-query';
import * as dealApi from '../deal.api';
import { callRefetchAllTasks } from 'resources/task/task.helpers';


export default function useDeleteTransaction() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (dealId) => dealApi.deleteTransaction({ dealId }),
    {
      onSuccess: async (removedDeal) => {
        if (!removedDeal) return;

        callRefetchAllTasks({
          queryClient,
          userIds: [currentUser?.id, removedDeal.realtor_id],
          companyId: removedDeal.company_id,
          dealId: removedDeal.id,
          dealClientIds: removedDeal.client_ids,
        });
      },
    });
}